import React from 'react';

const LetterLogo = (props) => {
  return (
    <svg
      width="20"
      height="28"
      viewBox="0 0 20 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.92154 19.3873L4.92154 28L0 28L-1.1832e-06 0.931542L4.92154 0.931542L4.92154 14.4658L9.84308 14.4658L9.84308 19.3873L4.92154 19.3873Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7646 14.4658L14.7646 28L19.6862 28L19.6862 0.931542L14.7646 0.931542L14.7646 9.54423L9.84308 9.54423L9.84308 14.4658L14.7646 14.4658Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LetterLogo;
